export default "__VITE_ASSET__c6b8e0bd__"